import { Typography, Row, Col, Space } from 'antd';

const { Title, Text } = Typography;

function DescriptionItem(props) {
  return (
    <Space align="center" className='desc-item-style'>
      <Title level={4}>
        {props.title}
      </Title>
      <Text type="secondary">
        {props.description}
      </Text>
    </Space>
  );
}

export default DescriptionItem;
